<template>
  <div class="addr-box">
    <van-form :show-error-message="false" validate-trigger="onChange" @submit="submit" @failed="failed">
      <div class="title-info flex-sb" @click="handleOpenSearch">
        <div style="flex: 1;overflow: hidden;">
          <div class="address-title">{{ mapCenterInfo.title }}</div>
          <div class="details-address">{{mapCenterInfo.detailedAddress}}</div>
        </div>
        <div class="update-address-btn">
          更改地址
          <i class="iconfont icon-qianjin" style="font-size: 10px;color: #C9C2BB;margin-left: 2px;"></i>
        </div>
      </div>
      <van-cell-group inset :border="false">
        <div class="input-box">
          <van-field
            v-model.trim="form.remark"
            label="详细地址"
            name="详细地址"
            placeholder="如：1栋2206"
            class="input"
            @blur="formChange"
          />
        </div>
        <div class="input-box">
          <van-field
            v-model.trim="form.realName"
            label="联系人"
            name="姓名"
            placeholder="姓名"
            class="input"
            style="width: 348px;"
            :rules="[{ required: true, message: '请填写姓名' }]"

            @blur="formChange"
          />
          <div style="height: 18px;border-right: 1px solid #C9C9C9;"></div>
          <van-field
            v-model.trim="form.phoneNumber"
            name="手机/座机"
            placeholder="手机/座机"
            class="input"
            :rules="[
              { required: true, message: '请填写手机/座机' },
              { pattern: /^((0\d{2,3}-\d{7,8})|(1\d{10})|(\d{7,8}))$/, message: '请填写正确的手机/座机' },
            ]"
            @blur="formChange"
          />
        </div>
        <div class="input-box">
        <van-field
            v-model.trim="form.factoryName"
            label="工厂名称"
            name="工厂名称"
            placeholder="工厂名称"
            class="input"
            @blur="formChange"
          />
        </div>
      </van-cell-group>
      <div class="footer" v-if="$route.query.id">
        <van-button 
          round block 
          type="warning" 
          native-type="submit" 
          class="footer-button"
        >确认修改地址</van-button>
      </div>
      <div class="footer" v-else>
        <van-field name="radio" class="group-addr" :border="false">
          <template #input>
            <van-radio-group v-model="form.groupAddr" direction="horizontal" @change="formChange">
              <van-radio :name="false" :disabled="groupAddrDisabled" icon-size="14" checked-color="#F1892E">个人地址簿</van-radio>
              <van-radio :name="true" :disabled="groupAddrDisabled" icon-size="14" checked-color="#F1892E">所在用户组</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-button 
          round block 
          type="warning" 
          native-type="submit" 
          class="footer-button"
          style="width: auto;"
        >确认新增地址</van-button>
      </div>
      <van-number-keyboard safe-area-inset-bottom />
    </van-form>
  </div>
</template>

<script>
import { Image , Field , Cell , CellGroup , Form , RadioGroup, Radio , Button , Toast , NumberKeyboard  } from 'vant';
export default {
  name:'dispatch-address-info',
  props:['mapCenterInfo','openSearch','queryParams'],
  components:{ 
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [NumberKeyboard.name]: NumberKeyboard,
    
   },
  data(){
    return {
      form:{
        groupAddr:0,
        realName:'',
        phoneNumber:'',
        remark:'',
        factoryName:''
      }
    }
  },
  watch:{
    queryParams:{
      handler(val){
        this.form = {
          groupAddr:val.groupAddr,
          realName:val.realName,
          phoneNumber:val.phoneNumber,
          remark:val.remark,
          factoryName:val.factoryName
        }
      },
      deep:true,
      immediate:true
    }
  },
  computed:{
    groupAddrDisabled(){
      return this.$route.query.groupAddr?JSON.parse(this.$route.query.groupAddr):false;
    }
  },
  methods:{
    formChange(){
      this.$emit('update:queryParams',{
        ...this.queryParams,
        ...this.deepClone(this.form)
      })
    },
    handleOpenSearch(){
      this.$emit('update:openSearch',true);
    },
    submit(){
      window.uni.postMessage({
        data: this.queryParams
      });
      window.uni.navigateBack({
				delta:1
			})
    },
    failed({ errors }){
      Toast.fail(errors[0].message);
    }
  }
}
</script>

<style scoped lang="scss">
  .addr-box {
      background-color: #FFF;
      box-sizing: border-box;
      padding: 0 12px;
      * {
        color: #130A01;
      }
      .van-form {
        .van-cell-group {
          margin: 0;
        }
        .title-info {
          overflow: hidden;
          padding: 12px 16px;
          margin: 16px 0;
          background-color: #F8F8F8;
          .details-address {
            font-size: 12px;
            line-height: 20px;
            color: #85807B;
          }
          .address-title {
            font-size: 18px;
            font-weight: bold;
            line-height: 26px;
            color: #3D3833;
          }
          .update-address-btn {
            flex-shrink: 0;
            margin-left: 13px;
            height: 24px;
            background-color: #FFF;
            border-radius: 2px;
            overflow: hidden;
            border: 1px solid #F5F1EF;
            font-size: 12px;
            line-height: 24px;
            padding: 0 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            counter-reset: #3D3833;
          }
        }
        .group-addr {
          padding: 0;
          width: auto;
          ::v-deep .van-radio__label {
            font-size: 14px;
            line-height: 30px;
          }
        }
        .input-box {
          height: 36px;
          overflow: hidden;
          background-color: #F5F5F5;
          border-radius: 6px;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          .input {
            background-color: #F5F5F5;
            height: 36px;
            line-height: 16px;
            font-size: 16px;
          }
        }
        .footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          .footer-button {
            flex-shrink: 0;
            height: 44px;
            border-radius: 4px;
            font-size: 16px;
            background: #EC892E;
            line-height: 44px;
            user-select: none;
            padding: 0 24px;
            * {
              color: #FFF;
            }
          }
        }
      }
    }
    ::v-deep .van-field {
      align-items: center;
      .van-field__label {
        width: auto;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        color: #1E1E1E;
      }
      .van-field__value {
        font-size: 16px;
        line-height: 24px;
      }
    }
</style>